import * as React from 'react';
import styled from 'styled-components';
import { SingleBlock as SB} from '@process-advisor/process-miner/components/layout/singleBlock';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { getColor} from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/cost/costsDataGrid';
import { Event } from '@process-advisor/process-miner/api/events';
import { costsGridColumns } from '@process-advisor/process-miner/cost/costsColumns';

export type Row = {};

export const SingleBlock = styled(SB)`
    align-items: center;
`;

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    background-color: ${getColor('white')};
    padding-top: 10px;
    padding-bottom: 10px;
`;

export const Costs: React.FC = () => {
    const [data, setData] = React.useState<Row[]>([]);
    const [supressMenu, setSupressMenu] = React.useState(true)

    React.useEffect(() => {
        setData(apiProvider.costsSummary());
        if (apiProvider.costsSummary().length > 0) {setSupressMenu(false)}
    }, []);


    React.useEffect(() => {
        const listener = () =>
            setData(apiProvider.costsSummary());
            if (apiProvider.costsSummary().length > 0) {setSupressMenu(false)}
        listener();

        apiProvider.on(Event.updateCost, listener);

        return () => {
            apiProvider.off(Event.updateCost, listener);
            };
    }, []);

    const rows = data.map((row, id) => ({ id, ...row }));
    

    return (
        <Wrapper>
            <SingleBlock>
                <DataGrid
                    rows={rows}
                    type={'cost'}
                    columns={costsGridColumns()}
                    supress_menu={supressMenu}
                />
            </SingleBlock>
        </Wrapper>
    );
};

